__webpack_require__.p = "/canvas-react-snake/";